module.exports = __webpack_public_path__ + "static/img/6.bb6e59b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/6.jpg
// module id = Vhvk
// module chunks = 5